import React from "react";
import { Modal } from "@campgladiator/cgui-core.molecules.modal";
import { ButtonProps } from "@campgladiator/cgui-core.atoms.button";
import { Option } from "@campgladiator/cgui-core.atoms.dropdown";
import { ProductDetailDTO, Role } from "@campgladiator/cg-common.types.types";
import { PaymentManagement } from "@campgladiator/cg-common.ui.payment-management";
import styles from "./CreateMembershipModal.module.scss";
import useWithCreateMembershipModal from "./hooks/useWithCreateMembershipModal";
import { CreateMembershipSelectProduct } from "./components/CreateMembershipSelectProduct";
import { CreateMembershipConfirm } from "./components/CreateMembershipConfirm";
import { TermsAndConditions } from "../TermsAndConditions";

export type CreateMembershipModalProps = {
  isInitialLoading: boolean;
  onClose?: (success?: boolean) => void;
  productDetails: ProductDetailDTO[];
  productOptions: Option[];
  role: Role;
  sellingTrainerId: string;
  stripeCustomerId: string;
  theme: ButtonProps["theme"];
  userId: string;
};

export type CreateMembershipModalSteps =
  | "selectProduct"
  | "selectPaymentMethod"
  | "confirm"
  | "terms";

const CreateMembershipModal = ({
  onClose,
  theme,
  isInitialLoading,
  productOptions,
  productDetails,
  sellingTrainerId,
  stripeCustomerId,
  userId,
  role,
}: CreateMembershipModalProps) => {
  const {
    title,
    buttons,
    step,
    createMembershipSelectProductProps,
    paymentManagementProps,
    createMembershipConfirmProps,
    termsAndConditionsProps,
  } = useWithCreateMembershipModal({
    onClose,
    theme,
    isInitialLoading,
    productDetails,
    productOptions,
    userId,
    stripeCustomerId,
    sellingTrainerId,
    role,
  });

  const renderByStep = () => {
    switch (step) {
      case "selectProduct":
        return (
          <CreateMembershipSelectProduct
            {...createMembershipSelectProductProps}
          />
        );
      case "selectPaymentMethod":
        return <PaymentManagement.AddOrEdit {...paymentManagementProps} />;
      case "confirm":
        return <CreateMembershipConfirm {...createMembershipConfirmProps} />;
      case "terms":
        return (
          <div className={styles.terms}>
            <TermsAndConditions {...termsAndConditionsProps} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      title={title}
      onClose={onClose}
      buttons={buttons}
      className={styles.modal}
      isVisible
    >
      <div className={styles.content}>{renderByStep()}</div>
    </Modal>
  );
};

export default CreateMembershipModal;
